import { atom } from 'recoil'

const searchParamsState = atom({
  default: {},
  key: 'searchParams',
})

export default searchParamsState
